import React from 'react'
import { Navigate } from 'react-router-dom'
import { RoutePaths } from '@assembly/constants'

export default function Billing() {
    // Redirect to the first submenu item (Usage Billing)
    return <Navigate to={RoutePaths.UsageBilling} replace />
}



